export default function restoreInit(art, events) {
    //
}
